import { useId, type ReactNode } from 'react';

/**
 * A control the approved design shows but that has no real implementation yet (Email, Download PDF). It is never faked: it stays keyboard-focusable
 * (`aria-disabled`, not `disabled`, so the reason reaches keyboard and screen-reader users), does nothing when activated and always exposes the reason.
 * BACKEND GAP: server-side PDF (library decision) and Email (verified contractor address + email template) are the next phase.
 */
export function ComingSoon({ label, reason, className, children }: { label: string; reason: string; className: string; children: ReactNode }) {
  const id = useId();
  return (
    <span className="cp-soon">
      <button type="button" className={className} aria-disabled="true" aria-label={`${label} (coming soon)`} aria-describedby={id} title={reason} onClick={(e) => e.preventDefault()}>
        {children}
      </button>
      <span role="tooltip" id={id} className="cp-tooltip">{reason}</span>
    </span>
  );
}
